<proffeo-ui-select
  (valueChange)="onStatusChange($event)"
  [disabled]="readonly()"
  [optionTemplate]="statusOptionTemplate"
  [options]="statusOptions"
  [triggerTemplate]="statusTriggerTemplate"
  [value]="selectedStatus()"
  appearance="inline"
/>

<ng-template
  #statusTriggerTemplate
  let-selectedOptions="selectedOptions"
>
  @if (selectedOptions[0]; as selectedOption) {
    <proffeo-ui-status-badge
      [density]="badgeDensity()"
      [mode]="statusBadgeMode()"
      [showLabel]="showLabel()"
      [status]="selectedOption.value"
      [matTooltip]="selectedOption.label | translate"
      [matTooltipDisabled]="showLabel()"
    />
  }
</ng-template>

<ng-template
  #statusOptionTemplate
  let-option="option"
>
  <proffeo-ui-status-badge
    [density]="badgeDensity()"
    [showLabel]="true"
    [status]="option.value"
    mode="dot"
  />
</ng-template>
